import type { ReactNode } from 'react'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetTitle,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetSection,
} from '@/components/ModalSheet'
import { Form, FormRow } from '@/components/Form'
import { Button } from '@/components/Button'
import { ErrorBlock } from '@/components/ErrorBlock'

export interface NewUserTransactionModalProps {
  showing: boolean
  isCreatePending: boolean
  onClose: () => unknown
  onSubmit: () => unknown
  hasValidationErrors: boolean
  error?: unknown
  workspaceSelector: ReactNode
  recipientSelector: ReactNode
  amountInput: ReactNode
  transactionTypeSelector: ReactNode
  transactionReasonSelector: ReactNode
  memoInput: ReactNode
  confirmModal: ReactNode
}

export function NewUserTransactionModal({
  showing,
  isCreatePending,
  onClose,
  onSubmit,
  hasValidationErrors,
  error,
  workspaceSelector,
  recipientSelector,
  amountInput,
  transactionTypeSelector,
  transactionReasonSelector,
  memoInput,
  confirmModal,
}: NewUserTransactionModalProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isCreatePending ? undefined : onClose}
      disableCloseOnEsc
    >
      <>
        <ModalSheetHeader withCloseButton bordered>
          <ModalSheetTitle emphasized>Add transaction</ModalSheetTitle>
        </ModalSheetHeader>
        <ModalSheetContent>
          <ModalSheetSection spaced>
            <Form onSubmit={onSubmit}>
              <FormRow>{workspaceSelector}</FormRow>
              <FormRow>{recipientSelector}</FormRow>
              <FormRow>{amountInput}</FormRow>
              <FormRow>{transactionTypeSelector}</FormRow>
              <FormRow>{transactionReasonSelector}</FormRow>
              <FormRow>{memoInput}</FormRow>
            </Form>
          </ModalSheetSection>
        </ModalSheetContent>
        {hasValidationErrors && (
          <ErrorBlock tackOn="bottom" error="There are validation errors." />
        )}
        {!!error && <ErrorBlock tackOn="bottom" error={error} />}
        <ModalSheetFooter>
          <ModalSheetFooterSpacer />
          <ModalSheetFooterButtonGroup>
            <Button
              label="Close"
              isDisabled={isCreatePending}
              onPress={onClose}
            />
            <Button
              label="Add Transaction"
              isDisabled={isCreatePending}
              isPending={isCreatePending}
              variant="primary"
              onPress={onSubmit}
            />
          </ModalSheetFooterButtonGroup>
        </ModalSheetFooter>
        {confirmModal}
      </>
    </ModalSheet>
  )
}
